
import {Component, Prop, Vue} from 'vue-property-decorator'
import { goToMessage } from '@/utils/h5ToApp'
import { Action } from 'vuex-class'
import { getUnreadInfoCount } from '@/api/commonConfig'

@Component
export default class Message extends Vue {
  @Action setMessageNo!: (val: number | null) => void;
  @Prop({default:'#fff'}) color:string
  messageNo = null

  created(){
    this.getMessageNo()
  }

  mounted () {
    // this.refreshPage()
    // document.addEventListener('visibilitychange', () => {
    //   if(document.hidden) {
    //     this.getMessageNo()
    //   }
		// })
  }

  /**
   * 当点击底部导航，页面切换时，原生调用h5接口，重新获取未读消息条数
   */
  refreshPage () {
    this.$bridge.registerHandler('refreshPage', (data: string, responseCallback) => {
      this.getMessageNo()
    })
  }

  /**
   * 获取消息未读条数
   */
  getMessageNo() {
    getUnreadInfoCount({}).then((res) => {
      this.messageNo = res.data && res.data.unreadCount
      this.setMessageNo(this.messageNo)
    })
  }

  /**
   * @description: 跳消息管理
   * @param {*}
   * @return {*}
   */
  toMessage () {
    goToMessage()
  }
}
